<template>
  <div>
    <input
      v-model="rne"
      placeholder="Ingrese su RNE"
      @keyup.enter="retrieveStudentsWithRNE(rne)"
    >
    <div v-if="!student_selected">
      <button
        v-for="(student, index) in students"
        :key="index"
        @click="selectStudent(student)"
      >
        {{ student.nombre_completo }}
      </button>
    </div>
    <button @click="submitSelectedStudent">
      Continuar
    </button>
  </div>
</template>
<script>
import { studentsService } from '../../_services';

export default {
    name: 'BaseLogin',
    data() {
        return {
            students: [],
            rne: '',
            student_selected: null,
            exists: false,
        };
    },
    methods: {
        retrieveStudentsWithRNE(rne) {
            const queryParams = {
                rne,
            };
            studentsService.staticStudents(queryParams).then((response) => {
                this.students = response.data;
            });
        },
        selectStudent(student) {
            this.student_selected = student;
        },
        studentExists() {
            const queryParams = {
                rne: this.student_selected.rne,
            };
            studentsService.students(queryParams).then((response) => {
                if (response.data.length > 0) {
                    this.exists = true;
                }
                this.exists = false;
            });
        },
        submitSelectedStudent() {
            this.studentExists();
        },
    },
};
</script>
